import ActionType from '../actionTypes/graphicUploadActionType';

export interface GraphicUploadState {
    submit: ISubmitState;
    delete: ICommonState;
    consent: IConsentState;
}

interface ICommonState {
    failed: boolean;
    loading: boolean;
    success: boolean;
    finished: boolean;
}

interface IConsentState {
    accepted: boolean;
}

interface ISubmitState extends ICommonState {
    fileCount: number;
}

const commonState = {
    failed: false,
    loading: false,
    success: false,
    finished: false,
};

const submitState = {
    failed: false,
    loading: false,
    success: false,
    finished: false,
    fileCount: 0,
};

const stateSubmit = 'submit';
const stateDelete = 'delete';
const stateConsent = 'consent';
type SubState = typeof stateSubmit | typeof stateDelete | typeof stateConsent;

const getInitialState = (): GraphicUploadState => ({
    [stateSubmit]: {
        ...submitState,
    },
    [stateDelete]: {
        ...commonState,
    },
    [stateConsent]: {
        accepted: false,
    },
});

const resetSubmitState = (
    subStateName: SubState,
    state: GraphicUploadState
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        ...submitState,
    },
});

const start = (
    subStateName: SubState,
    state: GraphicUploadState
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: true,
        success: false,
        finished: false,
    },
});

const success = (
    subStateName: SubState,
    state: GraphicUploadState
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: false,
        success: true,
        finished: true,
    },
});

const submitSuccess = (
    subStateName: SubState,
    state: GraphicUploadState
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: false,
        success: true,
        finished: true,
        fileCount: 0,
    },
});

const fail = (
    subStateName: SubState,
    state: GraphicUploadState
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: true,
        loading: false,
        success: false,
        finished: true,
    },
});

const acceptConsent = (
    subStateName: SubState,
    state: GraphicUploadState
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        accepted: true,
    },
});

const setFileCount = (
    subStateName: SubState,
    state: GraphicUploadState,
    fileCount: number
): GraphicUploadState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        fileCount: fileCount,
    },
});

const reducer = (
    state = getInitialState(),
    action: any
): GraphicUploadState => {
    switch (action.type) {
        case ActionType.graphicUploadSubmit.start:
            return start(stateSubmit, state);
        case ActionType.graphicUploadSubmit.success:
            return submitSuccess(stateSubmit, state);
        case ActionType.graphicUploadSubmit.fail:
            return fail(stateSubmit, state);
        case ActionType.graphicUploadSubmit.reset:
            return resetSubmitState(stateSubmit, state);
        case ActionType.graphicUploadSubmit.setFileCount:
            return setFileCount(stateSubmit, state, action.fileCount);

        case ActionType.graphicUploadDelete.start:
            return start(stateDelete, state);
        case ActionType.graphicUploadDelete.success:
            return success(stateDelete, state);
        case ActionType.graphicUploadDelete.fail:
            return fail(stateDelete, state);

        case ActionType.graphicUploadConsent.accept:
            return acceptConsent(stateConsent, state);

        default:
            return state;
    }
};

export default reducer;
